import { useState } from 'react'

import { captureException, withErrorBoundary } from '@sentry/react'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { nanoid } from 'nanoid'

import { RouterSheetWithDirtyCheck } from '@/components/atoms/Sheet/RouterSheetWithDirtyCheck'
import { SentryErrorPage } from '@/pages/error/SentryErrorPage'
import { AdminPromotionPage } from '@/pages/promotions/AdminPromotionPage'
import { AdminPromotionCreateFormPage } from '@/pages/promotions/forms/AdminPromotionCreateFormPage'
import { isAdminPromotionType } from '@/pages/promotions/forms/isAdminPromotionType'

export const PromotionListWithFormComponent = () => {
  const { key } = Route.useLoaderData()
  const [isDirty, setIsDirty] = useState(false)

  return (
    <>
      <AdminPromotionPage />
      <RouterSheetWithDirtyCheck className="h-full w-[600px]" isDirty={isDirty}>
        <AdminPromotionCreateFormPage key={key} onDirtyChange={setIsDirty} />
      </RouterSheetWithDirtyCheck>
    </>
  )
}

export const Route = createFileRoute('/promotions/$initiativeId/national/create/$type')({
  component: withErrorBoundary(PromotionListWithFormComponent, {
    fallback: SentryErrorPage,
    beforeCapture: (scope) => scope.setTag('route', Route.fullPath),
  }),
  beforeLoad: ({ params }) => {
    if (!isAdminPromotionType(params.type)) {
      throw redirect({ from: Route.fullPath, to: '../..', replace: true })
    }
  },
  loader: () => ({
    key: nanoid(),
  }),
  onCatch: (error) => {
    captureException(error, { tags: { route: Route.fullPath } })
  },
})
